import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=1b09265e&scoped=true&"
import script from "./phoneLogin.vue?vue&type=script&lang=js&"
export * from "./phoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=1b09265e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09265e",
  null
  
)

export default component.exports